import TreeChart from "vue-binary-tree";

import { serverBus } from "@/main";
import { mathMixin } from "@/mixins/";

export default {
  name: "binaryTree",
  mixins: [mathMixin],
  components: {
    TreeChart
  },
  created() {
    this.getData();
  },
  data() {
    return {
      loading: false,
      treeData: [],
      searchString: ""
    };
  },
  methods: {
    clickNode(node) {
      this.getData(node.name);
    },
    getDirectUsers(){
      serverBus.$emit("getDirectUsers");
    },
    getData(uuid = this.$store.getters.currentUser.uuid) {
      this.loading = true;
      if (uuid === "search") uuid = this.searchString;
      this.$http({
        url: "/api/v1/client/trees/2?uuid=" + uuid,
        method: "get",
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken
        }
      })
        .then(response => {
          this.loading = false;
          this.treeData = this.updateTree(response.data);
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.show(error.response.data.message, {
            position: "top-right",
            duration: 5000,
            type: "error",
            closeOnSwipe: true
          });
        });
    },

    firstNode() {
      this.getData(this.$store.getters.currentUser.uuid);
    },

    updateTree(data) {
      return data
    },

    prevNode() {
      this.getData(this.treeData.parent_uuid);
    }
  }
};
